import React, { Component } from 'react';
import Items from './internal/items';
export default class Rows extends Component {
  render() {
    const {
      items,
      render,
      loadingLabel = 'Loading'
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      role: "rowgroup"
    }, /*#__PURE__*/React.createElement(Items, {
      items: items,
      loadingLabel: loadingLabel,
      render: render
    }));
  }
}